// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { application } from "./application"

import ModalController from "./modal_controller.js"
application.register("modal", ModalController)

import PushStateController from "./push_state_controller.js"
application.register("push-state", PushStateController)

import VideoLoadController from "./video_load_controller.js"
application.register("video-load", VideoLoadController)

import VideoSearchController from "./video_search_controller.js"
application.register("video-search", VideoSearchController)
